import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Notification, NotificationsFilter } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  notifications: Identifiable<Notification>[];
  filter: NotificationsFilter;
  totalPages: number;
  retrieveNotifications(
    request: Boundaries["retrieveNotifications"]["request"],
  ): void;
}

function useRetrieveNotifications(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveNotificationsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveNotificationsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveNotificationsRequestFailure,
    ),
    notifications: useSelector(selector.getNotifications),
    filter: useSelector(selector.getNotificationsFilter),
    totalPages: useSelector(selector.getNotificationsTotalPages),
    retrieveNotifications: core.retrieveNotifications,
  };
}

export { useRetrieveNotifications };
